export function getStripePublishableKey(sandbox: boolean = false): string {
  if (sandbox) {
    return import.meta.env.VITE_SANDBOX_STRIPE_PUBLISHABLE_KEY;
  }

  return import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
}

export const HELP_DOCS_URL = "https://docs.invup.me";
